var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.49967 17.4167C5.49967 18.425 6.32467 19.25 7.33301 19.25H14.6663C15.6747 19.25 16.4997 18.425 16.4997 17.4167V8.25C16.4997 7.24167 15.6747 6.41667 14.6663 6.41667H7.33301C6.32467 6.41667 5.49967 7.24167 5.49967 8.25V17.4167ZM16.4997 3.66667H14.208L13.5572 3.01583C13.3922 2.85083 13.1538 2.75 12.9155 2.75H9.08384C8.84551 2.75 8.60718 2.85083 8.44218 3.01583L7.79134 3.66667H5.49967C4.99551 3.66667 4.58301 4.07917 4.58301 4.58333C4.58301 5.0875 4.99551 5.5 5.49967 5.5H16.4997C17.0038 5.5 17.4163 5.0875 17.4163 4.58333C17.4163 4.07917 17.0038 3.66667 16.4997 3.66667Z",
    fill: "#04B7EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.c0a1e5d531151b809245815be5369254.svg";
export { ForwardRef as ReactComponent };